<div class="padding">
  <form [formGroup]="lienDetails">
    <app-term [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [errors$]="observableErrors$" [order]="order" [isDisabled]="isDisabled"></app-term>

    @if (uiConfiguration.lienDetailsConfiguration?.showAmount) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.amount' | transloco }}</mat-label>
            <input matInput data-testid="amount-field" [placeholder]="'common.labels.amount' | transloco" [formControlName]="'amount'" type="number">
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['amount']"
          [message]="amountError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showDateOfLien) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'orders.dateOfLien' | transloco }}</mat-label>
            <input matInput [matDatepicker]="dateOfLien" data-testid="date-of-lien-field" formControlName="dateOfLien"
              [placeholder]="'common.labels.yyyyMmDd' | transloco">
            <mat-datepicker-toggle matSuffix [for]="dateOfLien"></mat-datepicker-toggle>
            <mat-datepicker #dateOfLien></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.get('dateOfLien')!"
          [message]="dateOfLienError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showAdditionalInformation) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.additionalInformation' | transloco }}</mat-label>
            <textarea matInput data-testid="additional-information-field" [formControlName]="'additionalInformation'"
            [placeholder]="'orders.additionalInformation2' | transloco"></textarea>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['additionalInformation']"
          [message]="additionalInformationError$"></lib-error-bubble>
        </div>
      </div>
    }
  </form>
</div>